<template>
  <div class="person-profile content-box">
    <div class="person-header">
      <div class="picture-wrapper">
        <div class="picture"></div>
      </div>
      <div class="title-name ellipsis">
        <h5 class="title ellipsis">FREMHÆVET PERSON</h5>
        <h3 class="name ellipsis" @click="$root.trackEvent({ eventCategory: 'Click', eventAction: 'Fremhævet person', eventLabel: name })"><router-link :to="{ name: 'person', params: { id: resume.lassoId.substring(6) }}">{{name}}</router-link></h3>
      </div>
    </div>
    <div class="content">
      <expandable-resume v-if="resume" :resume="resume" :expandable="true" :goToByExpanding="true"></expandable-resume>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Entity } from '@/assets/js/helpers.js'
import ExpandableResume from '@/components/ExpandableResume'
export default {
  name: 'personProfile',
  data () {
    return {
      resume: {
        content: 'Mia Therese Wagner er registreret med sin første erhvervsrolle i et kommanditaktieselskab/partnerselskab i 2012, hvor hun i december stiftede firmaet ADVOKATPARTNERSELSKABET WAGNER. Udover at være stifter, blev Mia også registreret i firmaets direktion. Mia blev indsat i bestyrelsen sammen med Morten Ludvig Wagner og Morten Oliver Nicolai Wagner, og stoppede i virksomheden i 2018. Hun er ikke længere personlig ejer af ADVOKATPARTNERSELSKABET WAGNER. I dag er firmaet opløst - hvilket det har været siden det blev opløst efter frivillig likvidation d. 16.06.2018.'
          +'<br><br>Mia ejer alle firmaer gennem selskabet Mia Wagner Holding ApS, som hun ejer 50-67 % af. I alt har hun registreret ejerskab af 4 danske virksomheder gennem dette. Selskabet Mia Wagner Holding ApS var ved sidste regnskab registreret med en egenkapital på 788.931 DKK og havde likvide beholdninger på 7 DKK Herudover ejer Mia blandt andet 2-7 % af Lucia Care ApS, der ved seneste regnskab (2022) leverede et resultat på -1,7 mio. DKK Noteret i regnskabet er endvidere udfordringer vedr. going concern.'
          +'<br><br>Historisk set har Mia siddet i en større mængde bestyrelses- og direktionsposter. I alt har hun siddet i 19 direktioner og 14 bestyrelser - hvoraf 4 var som formand. Mia fik sine første poster i 2012, hvor hun indtrådte i både bestyrelse og direktion for Wagner Advokater P/S. hendes længste rolle har indtil nu været i Wagner Advokater P/S som bestyrelsesmedlem, hvor hun startede i 2012 - og sad i over 4 år. Hun sidder på nuværende tidspunkt på 3 bestyrelsesposter, blandt andet i bestyrelsen i Danmarks Eksport- og Investeringsfond - en post, Mia har haft siden august 2022.'
          +'<br><br>Mia har indtil d. 05.02.2020 haft en rolle som bestyrelsesformand i KFORKAGE ApS, der blev meldt \'under konkurs\' i marts 2020. Firmaet beskæftigede inden konkursen 5 ansatte.',
        shortVersion: true,
        firstName: 'Mia',
        lastName: 'Wagner',
        lassoId: 'CVR-3-4003863161'
      }
    }
  },
  computed: {
    name: function () {
      return this.resume.firstName + ' ' + this.resume.lastName
    },
    intials: function () {
      var allInitials = this.name.split(' ').map(s => (s.substring(0, 1))).join('').toUpperCase()
      if (allInitials.length > 3) return allInitials.slice(0, 1) + allInitials.slice(2)
      else return allInitials
    },
    profileComponent: function () {
      return { template: '<span>' + Vue.filter('linkify')(this.profile, false) + '</span>' }
    }
  },
  mounted: function () {
    // Entity.resume(this.lassoId, true).then(resume => { this.resume = resume })
  },
  components: {
    'expandable-resume': ExpandableResume
  }
}
</script>

<style lang="less" scoped>
  @import (reference) "~@oldShared/lasso/style/constants/colors";
  .person-profile {
    padding: 30px;
    display: flex;
    height: 100%;
    flex-direction: column;

    .person-header {
      flex: 0 1 auto;

      display: flex;
      @media (max-width: 559px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        .picture-wrapper {
          margin-bottom: 15px
        }
      }
      @media (min-width: 560px) {
        flex-direction: row;
        justify-content: center;
      }
      .picture-wrapper {
        padding-right: 20px;
        .picture {
          background-image: url(../assets/img/Mia_Wagner_koncerndirektør.jpg);
          background-size: contain;
          width: 70px;
          height: 70px;
          border-radius: 50%;
          // background: #f3f3f3;
          color: rgba(34, 34, 34, .4);
          font-size: 18px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .title-name {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        h5 {
          margin: 0 0 5px 0;
          font-size: 14px;
          line-height: 1.1;
          font-weight: 500;
          color: #FF8E61;

        }
        h3 {
          margin: 0;
          font-size: 27px;
          line-height: 32px;
          font-weight: 500;
          a {
            color: #222;
            &:hover {
              text-decoration: none;
              color: #FF8E61;
            }
          }
        }
      }

    }
    .content {
      margin-top: 30px;
      flex: 1 1 auto;
      overflow: hidden;

      p {
        line-height: 26px;
      }
    }
  }

</style>
